<template>
  <main class="view-send-activation-link d-flex justify-content-center align-items-center">
    <Envelope :configurations="EnvelopeConfigurations" />
    <SendActivationLinkAround />
  </main>
</template>

<script>
import Envelope from '@/components/Envelope.vue'
import SendActivationLinkAround from '@/components/SendActivationLinkAround.vue'
import SendActivationCoverText from '@/components/SendActivationCoverText.vue'

export default {
  name: 'SendActivationLink',
  components: {
    Envelope,
    SendActivationLinkAround,
    SendActivationCoverText
  },
  data () {
    return {
      EnvelopeConfigurations: {
        HasLetter: false,
        HasButton: false,
        HasStamp: true,
        HasCoverText: true,
        CoverText: SendActivationCoverText
      }
    }
  }
}
</script>
